var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgActiveSort(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "#F0F8FF",
    stroke: "#004884",
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#004884",
    fillRule: "nonzero",
    d: "M22.143 15.857c-.228 0-.446-.09-.606-.25L17 11.068l-4.537 4.537c-.334.335-.877.335-1.212 0-.335-.335-.335-.877 0-1.212l5.143-5.143c.16-.16.379-.251.606-.251.227 0 .445.09.606.251l5.143 5.143c.245.245.318.614.186.934-.133.32-.445.53-.792.53zm-4.537 9.463l5.143-5.142c.335-.335.335-.878 0-1.213-.335-.334-.878-.334-1.212 0L17 23.502l-4.537-4.537c-.334-.334-.877-.334-1.212 0-.335.335-.335.878 0 1.213l5.143 5.142c.16.161.379.251.606.251.227 0 .445-.09.606-.25z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveSort);
export default __webpack_public_path__ + "static/media/activeSort.0797d5031becbbb72eeefd0a3cf8e5d5.svg";
export { ForwardRef as ReactComponent };